import _ from 'underscore';

import {omitNull} from 'common/utils';


export default class ServiceAddress {
  /* eslint-disable camelcase */
  constructor({
    address_id,
    pickup,
    dropoff,
    hub,
  }) {
    this.type = 'address';
    this.address_id = address_id || null;
    this.pickup = pickup || false;
    this.dropoff = dropoff || false;
    this.hub = hub || false;
  }
  /* eslint-enable camelcase */

  clone() {
    return new ServiceAddress(this.serialize());
  }

  serialize() {
    return omitNull({
      address_id: this.address_id,
      pickup: this.pickup,
      dropoff: this.dropoff,
      hub: this.hub,
    });
  }

  isDifferent(other) {
    return !_.isEqual(this.serialize(), other.serialize());
  }
}



// WEBPACK FOOTER //
// ./src/common/types/ServiceAddress.js